import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useDashboardManifest } from '../hooks/useDashboardManifest'

interface AdminRouteProps {
  children: React.ReactNode
}

export function AdminRoute({ children }: AdminRouteProps) {
  // Point the manifest at dashboard-manifest.json while on /dashboard so the
  // dashboard can be added to the home screen as its own app. Must run before
  // the early returns below: hook order has to be identical on every render.
  useDashboardManifest()
  const { user, loading, isAdmin } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="min-h-screen bg-navy flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-gold border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  if (!user) {
    const redirectParam = `?redirect=${encodeURIComponent(location.pathname)}`
    return <Navigate to={`/login${redirectParam}`} replace />
  }

  if (!isAdmin) {
    return <Navigate to="/portal" replace />
  }

  return <>{children}</>
}
